import styled from 'styled-components';
import { Circle } from 'ui/icons/other/Circle';
import { DiamondLogo } from 'ui/logo/Logo';

export const AnimationContainer = styled.div`
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
`;

export const LoadingLogo = styled(DiamondLogo)`
  @keyframes pulse {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0.35;
    }
    100% {
      opacity: 1;
    }
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg) scale(1);
    }
    50% {
      transform: rotate(180deg) scale(0.75);
    }
    100% {
      transform: rotate(360deg) scale(1);
    }
  }

  animation: 1.25s spin cubic-bezier(0.4, 0.14, 0.3, 1) infinite both,
    1.25s pulse cubic-bezier(0, 0, 0.3, 1) infinite;
`;

export const LoadingCircle = styled(Circle)`
  circle {
    stroke-dasharray: 128;
    stroke-dashoffset: 118;
    transform-origin: center;
    animation: dash 3s ease-in-out infinite, rotate 1s linear infinite;
  }

  @keyframes dash {
    0% {
      stroke-dashoffset: 72;
    }
    50% {
      stroke-dashoffset: 118;
    }
    100% {
      stroke-dashoffset: 72;
    }
  }

  @keyframes rotate {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;
